import script from "./OnboardingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingModal.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingModal.vue?vue&type=style&index=0&id=ca8e54fe&lang=css"
import "./OnboardingModal.vue?vue&type=style&index=1&id=ca8e54fe&scoped=true&lang=scss"
import "./OnboardingModal.vue?vue&type=style&index=2&id=ca8e54fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca8e54fe"]])

export default __exports__